/**
 * Standard-SCO-Model
 * @class service_v3sSco
 * @memberOf v3sWbtPlayerApp:model
 * @extends v3sWbtPlayerApp:model.service_v3sSection
 */
angular.module('v3sWbtPlayerApp').factory('v3sSco', ["v3sItem", "v3sSection", function (v3sItem, v3sSection) {

    // instantiate the sco object
    var v3sSco = function (data) {
        this.sco = true;

        // use the original object constructor
        v3sSection.apply(this, arguments);

        this.statusExcludeFilter = ["not attempted"];

        if (!!this.masteryscore) {
            this.masteryscore = parseInt(this.masteryscore) || 100;
        }

        if (!!data && this.type === "standardSco" && (!data.parameters || data.parameters.indexOf("type") == -1)) {
            for (var i = 0; i < data.children.length; i++) {
                var item = data.children[i];
                if (item.type === "section") {
                    this.children[i] = new v3sSection(item);
                } else {
                    this.children[i] = new v3sItem(item);
                }
                this.children[i].parent = this;
            }
            this.updateExercisesCount();
        }
    };

    // use the original prototype
    v3sSco.prototype = new v3sSection();

    v3sSco.prototype.getScoredData = function () {
        var scoredData = { score: 0, count: 0, evaluated: 0 };

        if (this.isTrackable()) {
            scoredData.count = this.getScoredItemsCount();
            scoredData.score = this.isPassed() ? 100 : 0;
            scoredData.evaluated = this.isEvaluated() ? scoredData.count : 0;
        }

        return scoredData;
    };

    v3sSco.prototype.getScoredItemsCount = function () {
        return this.isTrackable() && this.scoredItems > 0 ? 1 : 0; //SCO ist eine Einheit
    };

    v3sSco.prototype.getMasteryscore = function () {
        return this.masteryscore;
    };

    v3sSco.prototype.getTreeParent = function () {
        return this.treeParent || this.parent;
    };

    v3sSco.prototype.allowEnter = function (toPage) {
        var allow = true;

        if (!toPage || toPage.isLocked()) {
            allow = false;
        }

        return allow;
    };

    v3sSco.prototype.allowExit = function () {
        return true;
    };

    v3sSco.prototype.getChangeCount = function () {
        var count = v3sSection.prototype.getChangeCount.call(this);
        count += v3sItem.prototype.getChangeCount.call(this) * 100; // SCO-Änderung soll höher bewertet sein

        return count;
    }

    return v3sSco;
}]);